// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Hsa3","notes":"Notes_notes__15yNe"};